/**
 * Vuex store module for synergy management
 */

export const SYNERGY_STATES = {
  COMPLETED: 'COMPLETED',
  IN_PROGRESS: 'IN_PROGRESS',
};

export default {
  namespaced: true,

  state: {
    loading: false,
    error: null,
  },

  mutations: {
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_ERROR(state, error) {
      state.error = error;
    },
  },

  actions: {
    /**
     * End a synergy exchange
     * @param {Object} context - Vuex action context
     * @param {Object} payload - Action payload
     * @param {Object} payload.exchange - Exchange to update
     * @param {boolean} payload.successful - Whether the exchange was successful
     */
    async endExchange({ commit, dispatch }, { exchange, successful }) {
      commit('SET_LOADING', true);
      try {
        const updatedExchange = {
          ...exchange,
          level_of_completion: SYNERGY_STATES.COMPLETED,
          successful,
        };
        await dispatch('exchanges/updateExchange', { exchange: updatedExchange }, { root: true });
      } catch (error) {
        commit('SET_ERROR', error);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },

    /**
     * Rate a synergy exchange
     * @param {Object} context - Vuex action context
     * @param {Object} payload - Action payload
     * @param {Object} payload.exchange - Exchange to rate
     * @param {Object} payload.review - Review details
     * @param {number} payload.review.rating - Rating value
     * @param {string} [payload.review.comments] - Optional review comments
     */
    async rateExchange({ commit, dispatch }, { exchange, review }) {
      commit('SET_LOADING', true);
      try {
        await dispatch('exchanges/rateExchange', { exchange, review }, { root: true });
      } catch (error) {
        commit('SET_ERROR', error);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },
  },

  getters: {
    isLoading: (state) => state.loading,
    error: (state) => state.error,
    isCompleted: (_, __, rootState, rootGetters) => (exchange) =>
      exchange.level_of_completion === SYNERGY_STATES.COMPLETED,
  },
};
